declare global {
    interface Window {
        REACT_APP_API_DOMAIN: string;
        REACT_APP_WS_URL: string;
        REACT_APP_ALLOWED_DOMAINS: string;
        REACT_APP_USER_API_DOMAIN: string;
        REACT_APP_ENV: string;
        REACT_APP_SERVICE_PREFIX: string;
        REACT_APP_DEFAULT_LANG: string;
    }
}

const REACT_APP_API_DOMAIN =
  window.REACT_APP_API_DOMAIN || process.env.REACT_APP_API_DOMAIN || '';
const REACT_APP_WS_URL =
  window.REACT_APP_WS_URL || process.env.REACT_APP_WS_URL || '';
const REACT_APP_ALLOWED_DOMAINS =
  window.REACT_APP_ALLOWED_DOMAINS || process.env.REACT_APP_ALLOWED_DOMAINS || '';
const REACT_APP_USER_API_DOMAIN =
  window.REACT_APP_USER_API_DOMAIN || process.env.REACT_APP_USER_API_DOMAIN || '';
const REACT_APP_ENV =
  window.REACT_APP_ENV || process.env.REACT_APP_ENV || 'development';
const REACT_APP_SERVICE_PREFIX =
  window.REACT_APP_SERVICE_PREFIX ?? process.env.REACT_APP_SERVICE_PREFIX ?? '';
const REACT_APP_DEFAULT_LANG =
  window.REACT_APP_DEFAULT_LANG || process.env.REACT_APP_DEFAULT_LANG || 'vi';

export {
    REACT_APP_API_DOMAIN,
    REACT_APP_WS_URL,
    REACT_APP_ALLOWED_DOMAINS,
    REACT_APP_USER_API_DOMAIN,
    REACT_APP_ENV,
    REACT_APP_SERVICE_PREFIX,
    REACT_APP_DEFAULT_LANG,
};